import { SetStateAction, useCallback, useEffect } from "react";

export interface HeaderHeightEvent extends Event {
    detail?: {
        headerHeight: number | undefined,
        cumilativeAlertBarsHeight: number | undefined
    }
}

interface HeaderHeightCalculationProps {
    setsecondaryNavTop: React.Dispatch<SetStateAction<number>>;
}

export function useHeaderHeightCalculation(props: HeaderHeightCalculationProps) {

    const { setsecondaryNavTop } = props;

    useEffect(() => {
        setSecondaryNavTopBasedOnHeaderHeight();

        //Listener to listen to any alert bars being added, and screen orientation change.
        document.addEventListener("headerHeightEvent", e => headerHeightEventHandler(e));

        if (screen.orientation) {
            screen.orientation.addEventListener("change", setSecondaryNavTopBasedOnHeaderHeight);
        } else {
            //Safari < v16.4
            window.addEventListener("resize", setSecondaryNavTopBasedOnHeaderHeight);
        }


        return () => {
            document.removeEventListener("headerHeightEvent", e => headerHeightEventHandler(e));
            if (screen.orientation) {
                screen.orientation.removeEventListener("change", setSecondaryNavTopBasedOnHeaderHeight);
            } else {
                //Safari < v16.4
                window.removeEventListener("resize", setSecondaryNavTopBasedOnHeaderHeight);
            }
        }
    }, []);

    /**
     * The alertbar code will dispatch an event to document whenever the alertbars are added or removed from the page.
     * We need to listen to these events and adjust the offset of our sticky nav accordingly.
     * Refer generic-promo-banner.js for details of dispatcher.
     */
    const headerHeightEventHandler = useCallback(
        (e: HeaderHeightEvent) => {
            const HeaderHeight = getHeaderHeight();

            if (!e.detail) return;
            const secondayNavOffsettop = (e.detail.headerHeight ?? HeaderHeight) + (e.detail.cumilativeAlertBarsHeight ?? 0);
            setsecondaryNavTop(secondayNavOffsettop);
        },
        [],
    )

    const setSecondaryNavTopBasedOnHeaderHeight = (e?: Event) => {
        setsecondaryNavTop(getHeaderHeight());
    }
}

export function getHeaderHeight() {
    const headers = document.querySelectorAll(".root header.site-header");
    const headerNativeHeight = [...headers].reduce((prev, headerElement) => {
        return prev + Math.round(
            headerElement?.getBoundingClientRect().height ?? 0
        );
    }, 0);

    return headerNativeHeight;
}